import SquareIcon from './SquareIcon'

export default SquareIcon
